/** Slots on the candidate home featured grid. */
export const FEATURED_HOME_SLOT_COUNT = 4

/**
 * Open-jobs page size when the featured set is short.
 * Active featured rows sort first on that list, so a page of 4 is often
 * entirely featured and leaves nothing to fill with.
 */
export const OPEN_JOBS_FILL_PAGE_SIZE = 24

export type FeaturedFillRow = {
  id: string
  is_featured?: boolean
  kind?: 'managed' | 'marketplace'
}

/**
 * Keep the featured rows, then pad with other live jobs until `limit`.
 * Featured ids and any other `is_featured` row are skipped. Non-featured
 * managed jobs come before marketplace jobs.
 */
export function fillThinFeaturedJobs<T extends FeaturedFillRow>(
  featured: readonly T[],
  openJobs: readonly T[],
  limit = FEATURED_HOME_SLOT_COUNT,
): T[] {
  const merged = featured.slice(0, limit)
  if (merged.length >= limit) return merged

  const seen = new Set(merged.map((row) => row.id))
  const fillers = openJobs.filter((row) => !seen.has(row.id) && !row.is_featured)
  const managed = fillers.filter((row) => row.kind !== 'marketplace')
  const marketplace = fillers.filter((row) => row.kind === 'marketplace')

  for (const row of [...managed, ...marketplace]) {
    if (merged.length >= limit) break
    if (seen.has(row.id)) continue
    seen.add(row.id)
    merged.push(row)
  }
  return merged
}
